import React, { Component } from 'react';
import { observer } from 'mobx-react';

import { modelOf } from '../../../prop-types';
import Address from '../../../models/Address';

@observer
export class AddressInfo extends Component {
  render() {
    const { address } = this.props;

    const name =
      address.company.length > 0
        ? address.firstname.length > 0 || address.lastname.length > 0
          ? `${address.company}, ${address.lastname} ${address.firstname}`
          : `${address.company}`
        : `${address.lastname} ${address.firstname}`;

    return (
      <div className="AddressInfo">
        <div className="AddressInfo__name">{name}</div>
        <div className="AddressInfo__address">
          {address.street_address && `${address.street_address}, `}
          {address.postal_code} {address.city}
          {address.country && `, ${address.country.name}`}
        </div>
        <div className="AddressInfo__phone">{address.telephone}</div>
      </div>
    );
  }
}

AddressInfo.propTypes = {
  address: modelOf(Address).isRequired
};

export default AddressInfo;



// WEBPACK FOOTER //
// ./src/components/address/AddressInfo/index.jsx